import { useMergeState } from '@/shared/lib/customHooks';

/**
 * Backs the RMA device-count drawer with the single piece of state it needs, the scrolled flag. Exposes the scroll handler that keeps isScroll in sync with the drawer body's scrollTop.
 *
 * @returns The drawer state and its scroll handler.
 */
const useDeviceCountDrawer = () => {
  const [state, setState] = useMergeState({
    isScroll: false,
  });

  /**
   * Tracks whether the RMA device-count drawer body is scrolled away from the top. Reads scrollTop off the scroll event's target and writes isScroll only when it disagrees with the stored flag.
   *
   * @param e - Scroll event carrying the scrolled element as its target.
   * @returns Nothing.
   */
  const handleScroll = (e: any) => {
    const { scrollTop } = e.target;
    if (scrollTop === 0 && state.isScroll) {
      setState({ isScroll: false });
    } else if (scrollTop !== 0 && !state.isScroll) {
      setState({ isScroll: true });
    }
  };

  return {
    state,
    handleScroll,
  };
};

export { useDeviceCountDrawer };
